define(
    'services/service.dialog',[
		"durandal/app",
		"plugins/dialog"
    ],

    function (app, dialog) {

        var service = {};

        // Shows a simple message box with the provided button options.
        service.showMessageBox = function (title, message, options) {
            dialog.MessageBox.setViewUrl("modals/MessageBox");
            return dialog.showMessage(message, title, options);
        };

        service.showErrorDialog = function (errors) {
            return dialog.show("modals/ErrorsModal", [errors]);
        };

        service.showDocumentActionErrorDialog = function(result) {
            return dialog.show("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
        };

        // Show a completely custom modal dialog.
        service.showDialog = function (module, activationData) {
            return dialog.show(module, activationData);
        };

        return service;
    }
);
